import { Search, MousePointerClick, TrendingUp } from 'lucide-react';
import { PageShell, ServiceHero, CTAFinal, ServiceLinks } from '../components/services/Shared';
import { Reveal } from '../components/Reveal';
import { useLang } from '../i18n';

const Column = ({ icon: Icon, tag, title, paragraphs, testid }) => (
    <Reveal className="h-full">
        <article className="h-full rounded-[1.4rem] bg-white border border-ink/10 p-8 lg:p-9 flex flex-col" data-testid={testid}>
            <div className="flex items-center justify-between">
                <div className="w-12 h-12 rounded-xl bg-pastelblue flex items-center justify-center text-ink">
                    <Icon size={22} strokeWidth={1.75} />
                </div>
                <span className="font-ink text-[10px] uppercase tracking-[0.24em] text-crimson border border-crimson/25 rounded-full px-3 py-1">{tag}</span>
            </div>
            <h3 className="font-display text-2xl font-semibold text-ink mt-6">{title}</h3>
            {paragraphs.map((p) => (
                <p key={p.slice(0, 24)} className="mt-4 text-[15px] text-ink/70 leading-relaxed">{p}</p>
            ))}
        </article>
    </Reveal>
);

export default function SeoSem() {
    const { t } = useLang();
    return (
        <PageShell titleKey="seosem_meta_t" descKey="seosem_meta_d" path="/servicios/seo-sem" waKey="wa_seosem">
            <ServiceHero eyebrowKey="sp_name_seo-sem" h1Key="seosem_h1" testid="seosem-hero" />

            <section className="py-20 lg:py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <Reveal>
                        <h2 className="font-display text-3xl lg:text-4xl font-semibold text-ink">{t('seosem_h2_dos')}</h2>
                        <p className="mt-4 max-w-2xl text-ink/70 leading-relaxed">{t('seosem_h2_intro')}</p>
                    </Reveal>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-12">
                        <Column
                            icon={Search}
                            tag="SEO"
                            title={t('seosem_seo_t')}
                            paragraphs={[t('seosem_seo_p1'), t('seosem_seo_p2'), t('seosem_seo_p3')]}
                            testid="seosem-seo-card"
                        />
                        <Column
                            icon={MousePointerClick}
                            tag="SEM"
                            title={t('seosem_sem_t')}
                            paragraphs={[t('seosem_sem_p1'), t('seosem_sem_p2'), t('seosem_sem_p3')]}
                            testid="seosem-sem-card"
                        />
                    </div>
                </div>
            </section>

            <section className="py-20 lg:py-24 bg-pastelcream/60 border-y border-ink/10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <Reveal>
                        <h2 className="font-display text-3xl lg:text-4xl font-semibold text-ink max-w-3xl">
                            {t('seosem_h2_pq')}
                        </h2>
                        <p className="mt-5 max-w-3xl text-ink/70 leading-relaxed text-base sm:text-lg">{t('seosem_pq_p1')}</p>
                        <p className="mt-4 max-w-3xl text-ink/70 leading-relaxed text-base sm:text-lg">{t('seosem_pq_p2')}</p>
                    </Reveal>
                    <Reveal delay={0.12}>
                        <div className="mt-10 inline-flex items-start gap-3 rounded-2xl bg-white border border-ink/10 px-6 py-4 max-w-3xl">
                            <TrendingUp size={20} className="text-crimson shrink-0 mt-0.5" />
                            <p className="text-sm text-ink/70">{t('seosem_nota')}</p>
                        </div>
                    </Reveal>
                </div>
            </section>

            <CTAFinal text={t('seosem_cta')} message={t('wa_seosem')} testid="seosem-cta" />
            <ServiceLinks currentId="seo-sem" />
        </PageShell>
    );
}
